import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AppSettings } from '../helpers';
import { AddToGalleryModel } from '../models/gallery';

@Injectable()
export class GalleryService {
    constructor(private http: HttpClient,
        private appSettings: AppSettings) { }

    create(model: any) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/gallery/create', model);
    }

    getGalleries() {
        return this.http.get(this.appSettings.ApiBaseUrl + '/api/gallery/get-galleries');
    }

    deleteGallery(id: number) {
        return this.http.delete(this.appSettings.ApiBaseUrl + '/api/gallery?id=' + id);
    }

    getSelectListItems() {
        return this.http.get(this.appSettings.ApiBaseUrl + '/api/gallery/get-select-list-items');
    }

    addToGallery(model: AddToGalleryModel) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/gallery/add-to-gallery', model);
    }
}



// WEBPACK FOOTER //
// ./src/services/gallery.service.ts